import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import { AppBar } from '@provider-portal/design-common/kalep/components/AppBar/AppBar';
import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';
import { IconButton } from '@provider-portal/design-common/kalep/components/IconButton/IconButton';
import { Toolbar } from '@provider-portal/design-common/kalep/components/Toolbar/Toolbar';

import { Burger } from '@bolteu/kalep-react-icons';

import {
  NavBarVenueSelector,
  NavBarVenueSelectorProps,
} from 'components/merchant-portal-2/NavBar/NavBarVenueSelector';

export interface NavBarHeaderProps {
  drawerWidth: number;
  venueSelector: NavBarVenueSelectorProps;
  onHandleDrawerToggle?: () => void;
  onSelectorOpen?: () => void;
  onSearchPerformed?: (searchQuery: string, resultsCount: number, searchCount: number) => void;
}

export function NavBarHeader({
  drawerWidth,
  venueSelector,
  onHandleDrawerToggle,
  onSelectorOpen,
  onSearchPerformed,
}: NavBarHeaderProps) {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = React.useCallback(() => {
    if (onHandleDrawerToggle) {
      onHandleDrawerToggle();
    }
  }, [onHandleDrawerToggle]);

  const styles = {
    width: { md: `calc(100% - ${drawerWidth}px)` },
    ml: { md: `${drawerWidth}px` },
    boxShadow: 'none',
    backgroundColor: theme.palette.colors.core.white,
  };

  if (!isMobileView) {
    return null;
  }

  return (
    <AppBar position="fixed" sx={styles}>
      <Toolbar sx={{ p: 1 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <IconButton
            aria-label="open menu"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, ml: 0 }}
            color="ghost"
          >
            <Burger />
          </IconButton>
          <NavBarVenueSelector
            parentName={venueSelector.parentName}
            storeName={venueSelector.storeName}
            selectedStoreId={venueSelector.selectedStoreId}
            stores={venueSelector.stores}
            storeAvailabilities={venueSelector.storeAvailabilities}
            storeAvailabilitiesLoading={venueSelector.storeAvailabilitiesLoading}
            onProviderSelect={venueSelector.onProviderSelect}
            showAddVenueButton={venueSelector.showAddVenueButton}
            onAddVenue={venueSelector.onAddVenue}
            onSelectorOpen={onSelectorOpen}
            onSearchPerformed={onSearchPerformed}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
